////
/// ============================================================================
/// COMPONENT / Subnav
/// ============================================================================
///
/// @link https://github.com/NickDJM/accessible-menu/
/// @group components
////

import {DisclosureMenu} from "accessible-menu";

export default () => {
    const containerElement = document.querySelector(".js-subnav");

    if (!containerElement) {
        return;
    }

    // Istanzio il menu
    const submenu = new DisclosureMenu({
        menuElement: containerElement.querySelector("ul"),
        controllerElement: containerElement.querySelector("button"),
        containerElement: containerElement,
        openClass: 'is-show',
        closeClass: 'is-hide',
    });
};
